import HomeNews from "./HomeNews";
import GridCardHomeNews from "./GridCardHomeNews";
import SideImageHomeNews from "./SideImageHomeNews";
import TabsViewHomeNews from "./TabsViewHomeNews";
import StackedHomeNews from "./StackedHomeNews";
import { useSelector } from "react-redux";

function HomeNewsWrapper() {
  const sitedata = useSelector((store) => store.global.loginData);

  return (
    <>
      {sitedata?.theme_latest_news === "carousel" ? (
        <TabsViewHomeNews />
      ) : sitedata?.theme_latest_news === "grid-card" ? (
        <GridCardHomeNews />
      ) : sitedata?.theme_latest_news === "side-image" ? (
        <SideImageHomeNews />
      ) : sitedata?.theme_latest_news === "stacked-overlay" ? (
        <StackedHomeNews />
      ) : (
        <HomeNews />
      )}

    </>
  );
}

export default HomeNewsWrapper;
